// @flow
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../ui/colors'

const propTypes = {
  children: PropTypes.any,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  secondary: PropTypes.bool
};

const defaultProps = {
  type: 'button'
};

const getHighlightColor = ({theme: { ButtonHighlightColor = colors.BRAND_GREEN }}) => ButtonHighlightColor

const getSecondaryHighlightColor = ({theme: { ButtonSecondaryColor = colors.BASIC_RED }}) => ButtonSecondaryColor

const StyledButton = styled.button`
  appearance: none !important;
  background: ${props => getHighlightColor(props) };
  color: white;
  border-width: 1px;
  border-style: solid;
  border-color: ${props => getHighlightColor(props) };
  border-radius: 2px;
  transition: background-color .15s, color .15s;
  
  ${props => props.secondary && `
    background: ${getSecondaryHighlightColor(props)};
    border-color: ${getSecondaryHighlightColor(props)};
    &:hover{
      border-color: ${getSecondaryHighlightColor(props)};
      color: ${getSecondaryHighlightColor(props)};
    }
  `}

  ${props => props.inverse && `
    background: transparent;
    color: ${getHighlightColor(props)};
    border-color: ${getHighlightColor(props) };
  `}
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1em;
  padding: 0.9375rem;
  ${({wide}) => wide && `
    padding-left: 1.875rem;
    padding-right: 1.875rem;
  `}
  
  box-sizing: border-box;
  text-transform: uppercase;
  ${props => props.notransform && `
    text-transform: none;
  `}

  .current-input-touch & {
    &:active:not([disabled]) {
      background: white;
      color: ${props => getHighlightColor(props) };

      svg {
        fill: ${props => getHighlightColor(props) };
      }

      ${props => props.secondary && `
        color: ${getSecondaryHighlightColor(props)};
        svg {
          fill: ${getSecondaryHighlightColor(props)};
        }
      `}
      
      ${props => props.inverse && `
        background: ${getHighlightColor(props)};
        color: white;

        svg {
          fill: white;
        }
      `}
    }
  }

  .current-input-mouse & {
    &:hover:not([disabled]) {
      background: white;
      color: ${props => getHighlightColor(props) };

      svg {
        fill: ${props => getHighlightColor(props) };
      }
      
      ${props => props.secondary && `
        color: ${getSecondaryHighlightColor(props)};
        svg {
          fill: ${getSecondaryHighlightColor(props)};
        }
      `}
      
      
      ${props => props.inverse && `
        background: ${getHighlightColor(props)};
        color: white;
        svg {
          fill: white;
        }
      `}
      ${props => props.inverseHover && `
          background: transparent;
          color: ${getHighlightColor(props)};
          border-color: ${getHighlightColor(props)};
          svg {
            fill: ${getHighlightColor(props)};
          }
      `}
    }
  }

  width: ${props => props.block ? '100%' : 'auto'};
  display: ${props => props.block ? 'block' : 'inline-block'};

  ${({noFocus}) => noFocus && `
    &:focus{
      outline: none;
    }
  `}

  &[disabled] {
    background: #d8d8d8;
    border-color: #d8d8d8;
    color: white;
    cursor: default;
  }
  ${({loading, theme}) => loading && `
    position: relative;
    &:before{
      position: absolute;
      content: '';
      display: block;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: inherit;
      border-radius: inherit;
    }
    &:after{
      position: absolute;
      content: '';
      display: block;
      top: calc(50% - 10px);
      left: calc(50% - 10px);
      margin: 0;
      width: 20px;
      height: 20px;
      border: 2px solid;
      border-radius: 50%;
      border-color: ${theme.ButtonHighlightColor} #f1f1f1 #f1f1f1;
      animation: rotating .75s linear infinite;
    }
  `}
`;

StyledButton.propTypes = propTypes;
StyledButton.defaultProps = defaultProps;
StyledButton.displayName = 'Button';

export default StyledButton;



// WEBPACK FOOTER //
// ./src/modules/common/components/button/Button.js